import { Box, useMediaQuery, useTheme } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions } from '../../../common';
import PersonalDataSection from './PersonalDataSection';
import CredentialsSection from './CredentialsSection';
import PermissionsSection from './PermissionsSection';

const UserDialog = ({
  open,
  onClose,
  editMode,
  selectedUser,
  onInputChange,
  onSelectChange,
  onSave,
  roles = [],
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const commonProps = {
    selectedUser,
    onInputChange,
    onSelectChange,
    isMobile,
    editMode,
  };

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'fullWidth'}>
      <DialogTitle>{editMode ? 'Editar Usuario' : 'Agregar Usuario'}</DialogTitle>

      <DialogBody sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: 3 }}>
        <Box sx={{ flex: 1 }}>
          <PersonalDataSection {...commonProps} />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          <CredentialsSection {...commonProps} />
        </Box>

        {!isMobile && (
          <Box
            sx={{
              width: '1px',
              backgroundColor: 'divider',
              mx: 2,
            }}
          />
        )}

        <Box sx={{ flex: 1 }}>
          <PermissionsSection {...commonProps} roles={roles} />
        </Box>
      </DialogBody>

      <DialogActions handleClose={onClose} handleSave={onSave} />
    </DialogContainer>
  );
};

export default UserDialog;
